import { FloatButton, Layout } from 'antd';
import { useMatch } from 'react-router';
import { AppFrame } from './AppFrame.tsx';
import { AppRoutes } from './AppRoutes';
import { AisLaunch } from './ais/AisLaunch';
import { AIS_LAUNCH_PATH } from './ais/aisSignin.ts';
import { SystemStatusWrapper } from './SystemStatusWrapper.tsx';
import { SCROLLER } from './utils/elementIds';

const { Content } = Layout;

// The AIS launch decides itself when the frame appears, so it never shows in the theme of no Zuweiser
export const AppPage = () =>
  useMatch(AIS_LAUNCH_PATH) ? (
    <AisLaunch />
  ) : (
    <AppFrame>
      <Content id={SCROLLER}>
        <SystemStatusWrapper>
          <AppRoutes />
        </SystemStatusWrapper>
      </Content>
      <FloatButton.BackTop target={() => document.getElementById(SCROLLER) as HTMLElement} visibilityHeight={2500} />
    </AppFrame>
  );
